// we import './bootstrap' like this
// to create an async boundary so that module federation can work
import('./bootstrap');
